import * as d3 from 'd3'

import { click, platformModifierKeyOnly } from 'ol/events/condition';
import Select from 'ol/interaction/Select';

import {
  addAttributesToForm, getSurfaceAttributes, updateFormWithPolygonAttributes
} from './functions'
import { getFeatureInfo, hideWmsInfo } from './getFeatureInfo'
import { OPERATION, setOperation } from './handlers'
import { canBeMerged, visibleMergeBtn } from './merge'
import {
  hideEditOptions, hideFeatureInfo, moveTabToOperations,
  showEditOptions, showFeatureInfo, showToolbar
} from './navigation'
import { materializeToast } from './notifications'
import {
  lowlightId, resetSVG, resizeMap, setComplete, updateSVG
} from './map/d3Renderer'
import { removableBorders, vectorLayer, updatedVectorLayer } from './map/layers'
import { map } from './map/tools'
import { editableRegion } from './server'
import {
  codemap, collection, CURRENT_GEOTYPE, currentToolbarWindow, debug,
  highlighted, i18n, setIsSVGSelected, locallyAr5, maxEditResolution,
  setHighlighted, updSurfaceWithPolyResAttrEntities, userCanEditLayers
} from './storage'
import {
  invisibleStylePoint,
  redSelectedStylePoint, redSelectedStyleLine, redSelectedStylePolygon,
  setRedStyle
} from './styles'

const plus = import.meta.env.MODE === 'ar5web_plus';

// Returns current active tab
export const getActiveTab = () => {
  let activeTab = -1;
  if (tabHome.classList.contains('active')) activeTab = 1;
  else if (tabOperations.classList.contains('active')) activeTab = 2;
  else if (tabDrawPick.classList.contains('active')) activeTab = 3;
  else if (tabSave.classList.contains('active')) activeTab = 4;
  return activeTab;
};

/*
* Check if a key is displayed for the user.
* display_column must be set to yes
* All date attributes are always set so skip them
*/
function isKeyDisplayed(key) {
  let keyDisplayed = false;
  updSurfaceWithPolyResAttrEntities.forEach(entity => {
    if (entity.column_id === key) {
      if (entity.display_column === 'yes' && entity.column_datatype !== 'date')
        keyDisplayed = true;
    }
  });
  return keyDisplayed;
}

// Check if any of the displayed attributes are not set.
export function noEmptyAttribute() {
  let noEmptyAttributes = true;
  selectClick.getFeatures().forEach(feature => {
    if (locallyAr5 && feature.get('informasjon') === null)
      feature.set('informasjon', '');
    const properties = feature.getProperties();
    feature.getKeys().forEach(key => {
      if (
        (key.indexOf('bruker_id2') > -1) || (key.indexOf('bruker_id3') > -1)
      ) return; // continue forEach getKeys
      const e = document.getElementById(key) || document.getElementsByName(key)[0];
      const visible = e?.offsetWidth > 0 || e?.offsetHeight > 0;
      if (
        (properties[key] === null && isKeyDisplayed(key))
        || (e && visible && !e.checkValidity())
      ) noEmptyAttributes = false;
    });
  });
  return noEmptyAttributes;
}

export function showDoneEditingBox(hide) {
  if (locallyAr5) { // managed with css invalid form
    // this is only needed not to show button when no change and valid form
    const fc = document.getElementById('formChanged');
    if (fc) fc.checked =  hide ? false : true;
    const ff = selectClick?.getFeatures();
    const last = ff?.item(ff.getLength() - 1);
    visibleMergeBtn(
      !hide && canBeMerged(ff),
      last && selectClick.getLayer(last).get('id') === 'removableBorders'
    );
  } else {
    // Using css invalid instead of following code.
    // const db = document.getElementById('doneButton');
    // db.style.display = hide ? 'none' : 'inline-block';
  }
}

export function showLineAttributes() {
  $('#info-box-text').hide();
  showDateSelection();
}

export function showPolygonAttributes() {
  if (CURRENT_GEOTYPE === 'point') $('#info-box-move-button').show();
  else $('#info-box-move-button').hide();

  $('#info-box-text').hide();
  $('#info-box-text-no-action').hide();
  showEditOptions();
}

const showDateSelection = () => {
  $('#info-box-line-attributes').show();
  if (locallyAr5) {
    document.getElementById('twdStep1').hidden = true;
    document.getElementById('twdStep2').hidden = false;
    const df = document.getElementsByName('datafangstdato');
    if (!plus && df[0]) df[0].value = '';
    if (!plus && typeof datafangstmetode !== 'undefined') datafangstmetode.value = '';
  }
};
export const hideDateSelection = () => {
  $('#info-box-line-attributes').hide();
  if (locallyAr5) document.getElementById('twdStep2').hidden = true;
};

export function showInfoBoxText() {
  $('#info-box-text').show();
  hideDateSelection();
  hideEditOptions();
}

export function showInfoBoxNoAction() {
  $('#info-box-text-no-action').show();
  hideDateSelection();
  hideEditOptions();
}

function changeInfoBoxText(text){
  $('#info-box-help-text').text(text);
}

function setPointAsSelectable() {
  setIsSVGSelected(false);

  // This selects a D3 feature (does not seem to be used)
  d3.selectAll('text').on('click', function() {
    // console.log('all black');
    d3.selectAll('text').style('fill', 'black');
    setIsSVGSelected(true);
    const value = d3.select(this).text();
    d3.select(this).text( function (d) {
      d.properties['selected'] = true;
      return value;
    });
  });

  // // This deselects features if user click outside a feature
  // d3.selectAll("body").on("click", function() {
  //   if (isSVGSelected) {
  //     setIsSVGSelected(false);
  //   } else {
  //     console.log('everything black');
  //     d3.selectAll("text").style("fill", "black");
  //   }
  // });
}

function removePointAsSelectable() {
  setIsSVGSelected(false);
  d3.selectAll('text').on('click', null);
  d3.selectAll('body').on('click', null);
}

export function removeSelectedFeature() {
  if (typeof features === 'undefined') { return; }
  collection.features.forEach(feature => {
    if (feature.properties['selected'] === true) {
      feature.properties['selected'] = false;
    }
  });
  updateSVG();
}

export let selectClick;
export function addClickHandlerOn(sl) {
  const selectableLayer = sl ? sl : updatedVectorLayer;
  let style;
  if (CURRENT_GEOTYPE === 'point') {
    style = redSelectedStylePoint;
    //setPointAsSelectable();
  } else if (CURRENT_GEOTYPE === 'line') {
    style = redSelectedStyleLine;
  } else {
    style = [selectableLayer.getStyle(), redSelectedStylePolygon];
  }
  selectClick = new Select({
    condition: click,
    layers: [selectableLayer],
    style: style,
    toggleCondition: platformModifierKeyOnly
  });

  if (debug < 11) console.log('Add select interaction for new features');
  map.addInteraction(selectClick);
  selectClick.on('select', e => {
    if (debug < 12) console.log('On select for new features');
    const selected = e.target.getFeatures();
    const lastSelected = selected.item(selected.getLength() - 1);
    if (lastSelected) updateFormWithPolygonAttributes(lastSelected);
    // console.log(selected.getLength(), 'selected features',
      // '(last operation selected', e.selected.length,
      // 'and deselected', e.deselected.length, 'features).'
    // );
  });
}

export function addEditClickHandler() {
  let style;
  if (CURRENT_GEOTYPE === 'point') {
    style = invisibleStylePoint;
    setPointAsSelectable();
  } else if (CURRENT_GEOTYPE === 'line') {
    style = redSelectedStyleLine;
  } else {
    style = null; // i.e. do not apply any style changes for selected features
  }

  selectClick = new Select({
    condition: click,
    // filter: (f, l) => f.getGeometry().getType() === 'MultiLineString',
    // hitTolerance: 1,
    layers: [removableBorders, vectorLayer],
    style: style,
    // style: f => selectClick.getLayer(f).get('id') === 'removableBorders' ?
    //   redSelectedStylePolygon : updatedVectorLayer.getStyle(),
    toggleCondition: platformModifierKeyOnly
  });

  updatedVectorLayer.getSource().clear();
  if (CURRENT_GEOTYPE !== 'surface') updatedVectorLayer.setStyle(style);
  else updatedVectorLayer.setStyle(redSelectedStylePolygon);

  if (debug < 12) console.log('add select interaction edit');
  map.addInteraction(selectClick);

  visibleMergeBtn(false); // hide it if we have gone through info

  if (selectedFeatureId) { // from info dialog to edit dialog
    selectedFeatureOl.setStyle(null); // reset style
    selectClick.getFeatures().push(selectedFeatureOl); // otherwise saving fails.
    updatedVectorLayer.getSource().addFeature(selectedFeatureOl);

    removePointAsSelectable();
    // Get geometry and attributes for this feature
    getSurfaceAttributes(selectedFeatureId);
    // selectedFeatureId = null; // reset for next time
    if (CURRENT_GEOTYPE !== 'point') selectedFeatureOl = null; // moving point
    map.removeInteraction(selectClick);
    return;
  }
  selectClick.on('select', e => {
    // console.log('on select edit', e.selected[0]?.getGeometry().getType());
    visibleMergeBtn(false); // reset
    // e.selected is not what we want: https://gis.stackexchange.com/a/386353
    const features = e.target.getFeatures();
    updatedVectorLayer.getSource().clear(); // needed at every click
    updatedVectorLayer.getSource().addFeatures(features.getArray());
    const numSelectedFeatures = features.getLength();
    if (debug < 16) console.log('numSelectedFeatures:', numSelectedFeatures);
    if (numSelectedFeatures > 0) {
      selectedFeatureOl = features.item(numSelectedFeatures - 1);
      const id = selectedFeatureOl.get('id');
      if (debug < 16) console.log('Selected feature id:', id);
      selectedFeatureId = id; // such that it can be lowlighted on avbryt
      setRedStyle(null, id);
      collection.features.forEach(feature => {
        if (feature.properties.id === id) feature.properties.selected = true;
      });
      removePointAsSelectable();
      const selectedLayerId = selectClick.getLayer(selectedFeatureOl).get('id');
      const removableBorder = selectedLayerId === 'removableBorders'
      // Get geometry and attributes for this feature
      if (!removableBorder) getSurfaceAttributes(id);
      else {
        addAttributesToForm([], 'invalidate form to hide doneButton');
        switchTab('DrawPick', 'Save'); // Move tab one to the right
        showEditOptions();
      }
      visibleMergeBtn(locallyAr5 && canBeMerged(features), removableBorder);
      // If you do not want updatedVectorLayer source to be cleared:
      if (!locallyAr5) selectClick.setActive(false);
      console.log('Fjern forrige linjen når du kan hoppe til andre punkt og vise svart');
    } // else no feature is selected
  });
}

export function bringUserBackToStart() {
  selectedFeatureId = null;
  selectedFeatureOl = null;
  setHighlighted(0);
  moveTabToOperations();
  // removeDatePickers();
  // map.getView().setMinZoom(minZoom);
  setOperation('none');
  // hideEditOptions();
  // hideFeatureInfo();
}

export function toastDestroy() {
  const toasts = document.getElementsByClassName('toast');
  for (let i = toasts.length - 1; i >= 0; i--) {
    // Just hide it, Materialize will destroy it when time its time has gone.
    if (toasts[i]) { toasts[i].style.display = 'none'; }
    // const parentNode = toasts[i] ? toasts[i].parentNode : null;
    // // To Materialize, Vel is jQuery.Velocity
    // Vel(toasts[i], { opacity: 0, marginTop: '-40px' }, { duration: 375,
    //   easing: 'easeOutExpo',
    //   queue: false,
    //   complete: function() {
    //     // Callback aborted
    //     // Removal not handled by materialize
    //     if (parentNode && toasts[i]) { parentNode.removeChild(toasts[i]); }
    //     if (debug < 12) { console.log(i, 'toast[i] removed'); }
    //   }
    // });
  };
}

export function switchTab(from, to) {
  const aFrom = document.getElementById('tab' + from);
  aFrom.classList.toggle('active');
  const aTo = document.getElementById('tab' + to);
  aTo.classList.toggle('active');
}

export const titleCase = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export function asTitle(prop) {
  const s = prop.split('.');
  let t = prop;
  const l = s.length;
  if ( l > 1 ) t = s[l - 1];
  if (locallyAr5 && t.indexOf('forstedatafangstdato') > -1) t = 'datafangstdato';
  return titleCase(t);
}

const filterAndSortProperties = (list) => {
  const flate = CURRENT_GEOTYPE === 'surface';
  const index = locallyAr5 ? {
    id: 1,
    arealtype: 2,
    treslag: 3,
    skogbonitet: 4,
    grunnforhold: 5,
    datafangstdato: 6,
    verifiseringsdato: 7,
    opphav: 8,
    klassifiseringsmetode: 9,
    informasjon: 10,
    editable: 11 // redigerbar
  } : {
    id: 1,
    anleggstype: 2, // datasett
    reindrift_sesongomrade_kode: 2, // datasett
    navn: 2,
    samebyid1: 2,
    samebyid2: 2,
    reinbeitebruker_id: 3, // reinbeitebruker
    alle_reinbeitebr_id: 4, // andre_reinbeitebrukere
    reinbeiteområde_id: 4, // reinbeiteområde
    registreringsversjon: 4,
    dom_dato: 4,
    dom_i_kraft: 4,
    dom_instans: 4,
    samebykontakt: 4,
    rettsavgjorelselenke: 4,
    felles_egenskaper: 5,
    forstedatafangstdato: 5,
    førstedatafangstdato: 5,
    verifiseringsdato: 6,
    oppdateringsdato: 7,
    opphav: 8,
    informasjon: 8,
    kvalitet: flate ? undefined : 9,
    maalemetode: 9,
    status: 10,
    slette_status_kode: 11, // slettet
    editable: 12 // redigerbar
  };
  const exclude = {
    eier: true, geometry: true, identifikasjon: true, kvalitet: true, saksbehandler: true
  };
  // console.log('original', list);
  list.filter(p => !index[p] && !exclude[p]).forEach(l => console.log('Legg til', l));
  return list.filter(p => index[p]).sort((a, b) => index[a] - index[b]);
};

let brukere;
const writeSingleInfoToList = (key, columnName, list) => {
  if (columnName && typeof columnName === 'object' && !Array.isArray(columnName))
    filterAndSortProperties(Object.keys(columnName)).forEach(k =>
      writeSingleInfoToList(k, columnName[k], list));
  else {
    if (debug < 16) console.log(key, columnName);
    if (key === 'id') { // show it when localhost, utv or test, not prod.
      const hn = window.location.hostname;
      const localhost = hn.includes('localhost');
      const utv = hn.includes('utv');
      const test = hn.includes('test');
      if (localhost || utv || test) {
        const currentTime = new Date();
        const t = currentTime.toLocaleString('no-NO');
        list.innerHTML += `<li><b>Id:</b> ${columnName} (${t})</li>`;
        return;
      } else return; // hide id from informations.
    } else if (key.indexOf('reinbeitebruker') > -1) {
      const code = columnName;
      if (code) columnName = codemap['reinbeitebruker'][code];
      brukere += 1;
      if (brukere === 1) {
        const b = document.createElement('b');
        b.innerHTML = `${i18n['Reinbeitebruker']}:`;
        const li = document.createElement('li');
        li.id = 'reinbeitebrukere';
        li.appendChild(b);
        li.innerHTML += ` ${code} (${columnName})`;
        list.appendChild(li);
      } else if (columnName) {
        const li = list.querySelector('#reinbeitebrukere');
        if (li) li.innerHTML += `, ${columnName}`;
      }
    } else if ((key.indexOf('noyaktighet') > -1) ||
              (key.indexOf('rights') > -1)) {
      // do not list it to avoid redundancy with reinbeitebruker
    } else {
      let skipForAr5 = false;
      if (key.indexOf('dom_instans') > -1) {
        if (codemap['dominstans'][columnName]) {
          columnName = translate(codemap['dominstans'][columnName]);
        }
      }
      if (key.indexOf('reinbeiteområde') > -1) {
        if (codemap['reinbeiteomrade'][columnName]) {
          columnName = translate(codemap['reinbeiteomrade'][columnName]);
        }
      }
      if (key.indexOf('sesongomrade') > -1) {
        if (codemap['sesongomrade'][columnName]) {
          columnName = translate(codemap['sesongomrade'][columnName]);
        }
      }
      if (key.indexOf('samebyid') > -1) {
        if (codemap.samebyid[columnName])
          columnName = codemap.samebyid[columnName];
      }
      if ( // datafangstmetode, nøyaktighet, synbarhet
        (key.indexOf('kvalitet') > -1) // when inside fellesegenskaper
        || key.indexOf('datafangstmetode') > -1
      ) {
        const s = key.split('.');
        const k = s[s.length - 1];
        if (codemap[k] && codemap[k][columnName]) {
          columnName = translate(codemap[k][columnName]);
        }
      }
      if (key.indexOf('anleggstype') > -1) {
        if (codemap['anleggstype'][columnName]) {
          columnName = translate(codemap['anleggstype'][columnName]);
        }
      }
      if (['opphav', 'klassifiseringsmetode'].indexOf(key) > -1) {
        if (codemap[key] && codemap[key][columnName])
          columnName = codemap[key][columnName];
      }
      if (
        (key.indexOf('slette_status') > -1) ||
        (key.indexOf('editable') > -1) ||
        (key.indexOf('utenfor') > -1)
      ) {
        // map 0/1 and false/true with nei/ja
        columnName = translate(columnName);
        if (key.indexOf('slette_status') > -1) skipForAr5 = true;
      }
      if (key.indexOf('status') === 0) {
        columnName = i18n[key][columnName];
        skipForAr5 = true;
      }
      if (key.indexOf('oppdateringsdato') > -1) skipForAr5 = true;
      if (key.indexOf('dato') > -1)
        columnName = new Date(columnName).toLocaleDateString('no-NO');
      if (key.indexOf('datafangstmetode') > -1) skipForAr5 = true;
      if (key.indexOf('synbarhet') > -1) skipForAr5 = true;

      // --- AR5 ---
      const kv = ['arealtype', 'grunnforhold', 'skogbonitet', 'treslag'];
      if (kv.indexOf(key) > -1) {
        const textFromNr = codemap[key][columnName];
        if (textFromNr) columnName = translate(textFromNr) + ` (${columnName})`;
      }

      if ( // in case back-end sends string istead of array:
        key.indexOf('alle_reinbeitebr_id') > -1 &&
        (typeof columnName === 'string' || columnName instanceof String)
      ) { columnName = columnName.split(','); columnName.shift(); }

      if (Array.isArray(columnName))
        columnName = columnName.filter(x => x).map(t =>
          `<span title="${codemap['reinbeitebruker'][t] || t}">${t}</span>`
        ).join(', ');

      if (!locallyAr5 || !skipForAr5) {
        columnName = columnName ?? ''; // empty string when null or undefined
        const b = document.createElement('b');
        b.innerHTML = `${translate(asTitle(key))}:`;
        const li = document.createElement('li');
        li.appendChild(b);
        li.innerHTML += ` ${columnName}`;
        list.appendChild(li);
      }
      if (key === 'editable') {
        if (columnName === 'ja') emphasise('geometry-change-attributes');
        if (columnName === 'nei') mitigate('geometry-change-attributes');
      }
    }
  }
};

function writeFeatureInfo(f, target) {
  const propList = document.createElement('ul');
  propList.id = 'propList';
  if (locallyAr5) {
    const geometry = f.getGeometry();
    if (geometry.getType().indexOf('Polygon') > -1) { // MultiPolygon too
      // Negative for one spesific polygon positioned here [13.36645, 65.10014]:
      // ol.sphere.getArea(geometry, map.getView().getProjection()) / 1000
      const dekar = Math.abs(geometry.getArea()) / 1000;
      const area = document.createElement('li');
      area.innerHTML = '<b>Areal (dekar):</b> ' + dekar.toLocaleString('no-NO');
      propList.appendChild(area);
    }
  }
  brukere = 0;
  filterAndSortProperties(f.getKeys()).forEach(key =>
    writeSingleInfoToList(key, f.get(key), propList)
  );
  target.appendChild(propList);
}

import reinbeitebruker from '/config/codes/reinbeitebruker_id.csv?raw';
import klassifiseringsmetode from '/config/codes/klassifiseringsmetode.csv?raw';
import arealtype from '/config/codes/ar5_arealtype.csv?raw';
import grunnforhold from '/config/codes/ar5_grunnforhold.csv?raw';
import bonitet from '/config/codes/ar5_skogbonitet.csv?raw';
import treslag from '/config/codes/ar5_treslag.csv?raw';
import opphav from '/config/codes/opphav.csv?raw';
import ran_l from '/config/codes/RAN_L_anleggstype.csv?raw';
import ran_p from '/config/codes/RAN_P_anleggstype.csv?raw';
import reinbeiteomrade from '/config/codes/reinbeiteomrade.csv?raw';
import dominstans from '/config/codes/dominstans.csv?raw';
import rhs_f from '/config/codes/RHS_F_reindrift_sesongomrade_kode.csv?raw';
import rhv_f from '/config/codes/RHV_F_reindrift_sesongomrade_kode.csv?raw';
import rso_f from '/config/codes/RSO_F_reindrift_sesongomrade_kode.csv?raw';
import rvi_f from '/config/codes/RVI_F_reindrift_sesongomrade_kode.csv?raw';
import rvr_f from '/config/codes/RVR_F_reindrift_sesongomrade_kode.csv?raw';
import samebyid from '/config/codes/samebyid.csv?raw';

const csvRaw = {
  reinbeitebruker_id: reinbeitebruker,
  klassifiseringsmetode,
  ar5_arealtype: arealtype,
  ar5_grunnforhold: grunnforhold,
  ar5_skogbonitet: bonitet,
  ar5_treslag: treslag,
  opphav,
  RAN_L_anleggstype: ran_l,
  RAN_P_anleggstype: ran_p,
  reinbeiteomrade,
  dominstans,
  RHS_F_reindrift_sesongomrade_kode: rhs_f,
  RHV_F_reindrift_sesongomrade_kode: rhv_f,
  RSO_F_reindrift_sesongomrade_kode: rso_f,
  RVI_F_reindrift_sesongomrade_kode: rvi_f,
  RVR_F_reindrift_sesongomrade_kode: rvr_f,
  samebyid
};

const codesFromCsv = (url, key) => {
  if (!codemap.hasOwnProperty(key)) codemap[key] = {};
  // fetch(url).then(r => r.text()).then(csv => {
  // import(url).then(r => r.default).then(csv => {
  const csv = csvRaw[url.split('.')[0]];
    const lines = csv.split(/\r?\n/); // split new line, both Linux and Win
    lines.forEach( line => {
      const s = line.split(',');
      const code = s[0];
      const value = line.slice(s[0].length + 1); // it might contain other commas, keep them
      if (code !== '') codemap[key][code] = value;
    });
};

export const getCodemap = (ar5) => {
  codesFromCsv('reinbeitebruker_id.csv', 'reinbeitebruker');
  codesFromCsv('klassifiseringsmetode.csv', 'klassifiseringsmetode');
  if (ar5) {
    codesFromCsv('ar5_arealtype.csv', 'arealtype');
    codesFromCsv('ar5_grunnforhold.csv', 'grunnforhold');
    codesFromCsv('ar5_skogbonitet.csv', 'skogbonitet');
    codesFromCsv('ar5_treslag.csv', 'treslag');
    codesFromCsv('opphav.csv', 'opphav');
  } else {
    codesFromCsv('RAN_L_anleggstype.csv', 'anleggstype');
    codesFromCsv('RAN_P_anleggstype.csv', 'anleggstype');
    codesFromCsv('reinbeiteomrade.csv', 'reinbeiteomrade');
    codesFromCsv('dominstans.csv', 'dominstans');
    codesFromCsv('RHS_F_reindrift_sesongomrade_kode.csv', 'sesongomrade');
    codesFromCsv('RHV_F_reindrift_sesongomrade_kode.csv', 'sesongomrade');
    codesFromCsv('RSO_F_reindrift_sesongomrade_kode.csv', 'sesongomrade');
    codesFromCsv('RVI_F_reindrift_sesongomrade_kode.csv', 'sesongomrade');
    codesFromCsv('RVR_F_reindrift_sesongomrade_kode.csv', 'sesongomrade');
    codesFromCsv('samebyid.csv', 'samebyid');
  }
};

const atsg = [];
import ar5combinations from '/config/ar5combinations.csv?raw';
export const loadAr5Combinations = () => {
  // The original table can be found as a pdf:
  // https://nibio.brage.unit.no/nibio-xmlui/bitstream/handle/11250/2596511/NIBIO_BOK_2019_5_5_v2.pdf
  // or as a PostgreSQL table: org_ar5.ar5_kode_standard
  const lines = ar5combinations.split(/\r?\n/); // split new line, both Linux and Win
  let skipHeader = true;
  lines.forEach( line => {
    if (skipHeader) { skipHeader = false; return; } // continue to next line
    const s = line.split(',');
    (s.length < 4) || atsg.push(s); // as text or s.map(Number) as number
  });
};

export const leftOptions = (arealtype, treslag, skogbonitet) => {
  const options = [];
  // An emtpy string parameter will return all values
  const a = (arealtype || arealtype === '');
  const t = (treslag || treslag === '');
  const s = (skogbonitet || skogbonitet === '');
  const c = (a ? 1 : 0) + (t ? 1 : 0) + (s ? 1 : 0);
  atsg.forEach(combination => {
    // console.log(combination);
    const v = combination[c];
    if (arealtype && arealtype !== combination[0]) return;
    if (treslag && treslag !== combination[1]) return;
    if (skogbonitet && skogbonitet !== combination[2]) return;
    (options.indexOf(v) > -1) || options.push(v);
  });
  return options;
};

export function translate(word) {
  if (i18n[word]) {
    // console.log('found', word, 'in dictionary. It translates to', i18n[word]);
    return i18n[word];
  }
  console.log(
    'Not found <<', word, '>> in dictionary. It will not be translated,',
    'add it to the dictionary.'
  );
  return word;
}

export let selectedFeatureId = null;
export const setSelectedFeatureId = (id) => selectedFeatureId = id;
export let selectedFeatureOl = null;
export const setSelectedFeatureOl = (ol) => selectedFeatureOl = ol;

export function onMouseClick(browserEvent) {
  hideWmsInfo();
  const editCard = document.getElementById('info-box-object-attributes').style;
  const stillWaitingForUserToFinishEditing = (editCard.display === 'block');
  if (stillWaitingForUserToFinishEditing) return; // do not show cards/colours
  if (locallyAr5 && (currentToolbarWindow !== 'info')) {
    hideFeatureInfo(); // remove old info and prepare ask-to-click text
    if (highlighted > 0) lowlightId(highlighted);
    return;
  }
  const coordinate = browserEvent.coordinate;
  const pixel = map.getPixelFromCoordinate(coordinate);

  const ibpt = document.getElementById('info-box-popup-text');
  ibpt.innerHTML = '';
  let numberOfFeatures = 0;
  const hitFeatures = [];
  let relativePosition = -1;
  if (selectedFeatureId) {
    // reset style
    lowlightId(selectedFeatureId); // only needed for myr in chrome
    if (selectedFeatureOl) selectedFeatureOl.setStyle(null);
    const selectedPointD3 = d3PointFromId(selectedFeatureId);
    if (selectedPointD3) {
      selectedPointD3.datum().properties.selected = false;
      selectedPointD3.style('fill', 'black');
    }
  }
  map.forEachFeatureAtPixel(pixel, feature => {
    numberOfFeatures += 1;
    hitFeatures.push(feature);
    const id = feature.get('id');
    if (selectedFeatureId === id) relativePosition = numberOfFeatures - 1;
  }, { hitTolerance: 0, layerFilter: l => l.get('id') === 'vectorLayer' });

  const hit = (numberOfFeatures > 0);
  if (hit) {
    if (debug < 16) console.log('hit');
    const nextPosition = (relativePosition + 1) % numberOfFeatures;
    const nextFeature = hitFeatures[nextPosition];
    selectedFeatureId = nextFeature.get('id');
    if (debug < 16) console.log('selectedFeatureId:', selectedFeatureId);
    selectedFeatureOl = nextFeature;
    setRedStyle(selectedFeatureOl, selectedFeatureId);
    if (numberOfFeatures > 1) {
      const b = document.createElement('b');
      b.innerHTML = `${i18n['Flere geometrier']} (${nextPosition + 1}${i18n['av']}${numberOfFeatures}):`;
      const p = document.createElement('p');
      p.appendChild(b);
      ibpt.appendChild(p);
    }
    writeFeatureInfo(nextFeature, ibpt);
    if (OPERATION !== 'add') showFeatureInfo(hit); // if not drawing
    // Display coordinates and UTM zone:
    const separator = document.createElement('hr');
    separator.style.margin = '8px 0';
    ibpt.appendChild(separator);
    const øst = coordinate[0].toFixed();
    const nord = coordinate[1].toFixed();
    const t = document.createElement('p');
    t.innerHTML = i18n[map.getView().getProjection().getCode()];
    ibpt.appendChild(t);
    const c = document.createElement('p');
    c.style.whiteSpace = 'nowrap';
    c.innerHTML = 'Nord, Øst: [ ' + nord + ', ' + øst + ' ]';
    t.appendChild(c);
  } else {
    if (debug < 16) console.log('not hit');
    setHighlighted(0);
    selectedFeatureId = null;
    selectedFeatureOl = null;
    updateSVG(); // to remove red style on previously selected feature
    emphasise('geometry-change-attributes');
    hideFeatureInfo();
    showToolbar('none');
    getFeatureInfo(coordinate, pixel);
  }

  resizeMap();
}

Array.prototype.remove = function(from, to) {
  const rest = this.slice((to || from) + 1 || this.length);
  this.length = from < 0 ? this.length + from : from;
  return this.push.apply(this, rest);
};

export function d3PointFromId(id) {
  let selectedPointD3 = null;
  if (id) {
    const d3Group = d3.select('#d3-map');
    const p = d3Group.selectAll('text').each(function(d) {
      if (d.properties['id'] === id) {
        d.properties['selected'] = true;
        selectedPointD3 = d3.select(this);
      } else if (d.properties['selected']) {
        d.properties['selected'] = false;
      }
    });
  }
  return selectedPointD3;
}

export const emphasise = (id) => {
  const r = map.getView().getResolution();
  if (userCanEditLayers && (r < maxEditResolution)) {
    // document.getElementById(id).disabled = false;
    // Re-enable click, handled by editableState as an if inside click function
    // Remove transparency:
    document.getElementById(id).style.opacity = 1;
  } else if (userCanEditLayers && (id === 'geometry-change-by-gps')) {
    document.getElementById(id).style.opacity = 1;
  }
};
export const mitigate = (id) => { // just mitigate it, a disabled button confuses users
  // document.getElementById(id).disabled = true;
  // No action on click, handled by editableState as an if inside click function
  // Add transparency:
  document.getElementById(id).style.opacity = 0.65;
};

export const editableState = () => {
  const r = map.getView().getResolution();
  if (!userCanEditLayers) {
    materializeToast('Du har ikke rettigheter', 'error');
    return false; // not necessary to show next message
  } else if (r >= maxEditResolution) {
    materializeToast('Zoom mer inn', 'error');
    return false;
  } else if (!editableRegion) {
    materializeToast('Utenfor lovlig område', 'error');
    return false; // not necessary to show next message
  } else if (bar.style.display === 'block') { // loading geometry
    materializeToast('Vent! Kartet må lastes inn før du kan oppdatere', 'error');
    return false; // not necessary to show next message
  }
  return true // userCanEditLayers && editableRegion && (r < maxEditResolution)
};

const whatChanged = (original, changed) => {
  const cmto = document.getElementById('changingMoreThanOne');
  const moreThanOne = selectClick.getFeatures().getLength() > 1;
  cmto.hidden = moreThanOne ? false : true;
  const ibcc = document.getElementById('info-box-confirm-content');
  ibcc.innerHTML = '<hr>'; // empty content at the same time.
  if (Object.keys(changed).length === 0) {
    changedDiv.innerHTML += 'Ingen endringer<hr>'
  } else {
    for (let key in changed) {
      const what = asTitle(key);
      const to = codemap[key] ? codemap[key][changed[key]] : changed[key];
      const f = codemap[key] ? codemap[key][original[key]] : original[key];
      const from = (f === undefined) ? 'Ingen informasjon' : f;
      const ff = '<span class="fromValue">Fra: <s>' + from + '</s></span>';
      const fra = moreThanOne ? '' : ff;
      ibcc.innerHTML += what +'<br>Til: <b>' + to + '</b>' + fra + '<hr>';
    }
  }
};
export const confirmChanges = (o, c) => {
  whatChanged(o, c);
  document.getElementById('tweStep2').hidden = true;
  document.getElementById('tweStep3').hidden = false;
};

export const activeButton = (btn) => {
  return ((btn.style.opacity === '') || (btn.style.opacity === '1'));
};

export const detectFormChanges = () => {
  const formFields = document.getElementsByClassName('form-update-attribute');
  const l = formFields.length;
  for (let i = 0; i < l; i++) {
    const attributeField = formFields[i];
    const id = attributeField.id;
    const pre = attributeField.defaultValue;
    const post = attributeField.value;
    // if (debug < 11) console.log(id, pre, post);
    if (pre !== post) {
      return true;
    }
  }
  return false;
};

export const closeElement = (id) => {
  document.getElementById(id).classList.add('closed');
};

